import React from 'react';

interface FileUploadValidationStatsProps {
  shapeCount: number;
  areaKm2: number;
}

function formatAreaKm2(areaKm2: number): string {
  const rounded = Math.round(areaKm2 * 100) / 100;
  const display = Number.isInteger(rounded)
    ? String(rounded)
    : rounded.toFixed(2);
  return `${display} km²`;
}

const FileUploadValidationStats: React.FC<FileUploadValidationStatsProps> = ({
  shapeCount,
  areaKm2
}) => {
  const stats = [
    { label: 'Feature(s) detected', value: String(shapeCount) },
    { label: 'Total area', value: formatAreaKm2(areaKm2) }
  ];

  return (
    <div className="byda-member-lookup__file-upload-validation-stats">
      {stats.map((stat, index) => (
        <React.Fragment key={stat.label}>
          {index > 0 && (
            <div className="byda-member-lookup__file-upload-validation-stats__divider" />
          )}
          <div className="byda-member-lookup__file-upload-validation-stats__item">
            <div className="byda-member-lookup__file-upload-validation-stats__value">
              {stat.value}
            </div>
            <div className="byda-member-lookup__file-upload-validation-stats__label">
              {stat.label}
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default FileUploadValidationStats;
